import { Box, Typography, List, ListItem, styled } from '@mui/material';
import React from 'react';

import { Label, LineItem, Maybe } from 'components';

const StyledVideoTitle = styled(Typography)(({ theme }) => ({
	marginLeft: 15
}));

const LessonDetails = ({ lesson }) => {
	return (
		<List>
			<Typography variant="h5">Basic Information</Typography>
			<LineItem label="Lesson Name" value={lesson.title} />
			<LineItem label="Lesson Description" value={lesson.description} />
			<LineItem label="Trainer" value={lesson.trainer?.name} />
			<LineItem label="Lesson category" value={lesson.category_name} />
			<LineItem
				label="Lesson positions"
				value={lesson?.positions?.join(', ')}
			/>

			<Typography variant="h5">Video Modifiers</Typography>
			<LineItem label="Main:" value={lesson?.video_modifier_main} />
			<LineItem label="Clip:" value={lesson?.video_modifier_clip} />
			<LineItem label="Thumbnail:" value={lesson?.video_modifier_thumbnail} />

			<Typography variant="h5">Videos</Typography>
			{lesson.video_url && (
				<>
					<StyledVideoTitle component="span" variant="body2">
						{'Lesson Video'}
					</StyledVideoTitle>
					<ListItem>
						<video
							src={lesson.video_url}
							controls
							muted
							height="240"
							width="auto"
						/>
					</ListItem>
				</>
			)}
			{lesson.video2_url && (
				<>
					<StyledVideoTitle component="span" variant="body2">
						{'Lesson Preview Video'}
					</StyledVideoTitle>
					<ListItem>
						<video
							src={lesson.video2_url}
							controls
							muted
							height="240"
							width="auto"
						/>
					</ListItem>
				</>
			)}

			<LineItem label="Created AT" value={lesson.created_at} />
			<LineItem
				label="Published"
				value={<Label label={lesson.published ? 'Yes' : 'No'} />}
			/>
			{/* <LineItem
				label="Premium"
				value={<Label label={lesson.premium ? 'Yes' : 'No'} />}
			/> */}
			<LineItem label="Level" value={lesson.level} />
			{/* <LineItem label="Duration" value={lesson.duration} /> */}

			{/* <Maybe display={!!lesson?.experience_points}>
				<LineItem label={'XP'} value={lesson?.experience_points} />
			</Maybe> */}
		</List>
	);
};

export default LessonDetails;
